import configureAxios from "init/axios";
import configureI18n from "init/i18n";
import MuiThemeProvider from "init/MuiThemeProvider";
import ReactQueryProvider from "init/ReactQueryProvider";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom/client";
import { ReactQueryDevtools } from "react-query/devtools";
import "./index.css";
import Routes from "./Routes";

configureI18n();
configureAxios();

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <MuiThemeProvider>
      <SnackbarProvider maxSnack={3}>
        <ReactQueryProvider>
          <ReactQueryDevtools initialIsOpen={false} />
          <Routes />
        </ReactQueryProvider>
      </SnackbarProvider>
    </MuiThemeProvider>
  </React.StrictMode>
);
